import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Badge} from "@material-ui/core";
import RenderComponents from "./RenderComponents";
import {useSelector} from "react-redux";
import {getParamsFromString} from "../../Utils";
import JsonScreenHoc from "../../../../HocHelpers/JsonScreenHoc";
import useWebSocket from "../../../../Hooks/useWebSocket";

const BadgeComponent = (props) => {
    const {component, basePath, containerArrayPath, actionsContext, screenName, doActions} = props;
    const {globalValues} = useSelector(state => state.jsonScreen)
    const {properties = {}, styles: sourceStyles, children, events} = component;
    const styles = sourceStyles ? sourceStyles[0] : {};
    const [badgeContent, setBadgeContent] = useState(0);
    useWebSocket(events, doActions);
    useEffect(() => {
        const value = getParamsFromString(properties.label, {...globalValues, ...actionsContext}, screenName)
        value && setBadgeContent(value === "0" ? 0 : value);
    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext)])

    return (
        <Badge color={styles.color || 'secondary'}
               variant={styles.variant || 'standard'}
               badgeContent={badgeContent}
               showZero={false}
               style={{
                   margin: styles.margin,
                   padding: styles.padding,
               }}
        >
            {children.map((element, index) => {
                return (
                    <RenderComponents
                        key={index}
                        basePath={basePath}
                        element={element}
                        containerArrayPath={containerArrayPath}
                        actionsContext={actionsContext}
                    />
                )
            })}
        </Badge>
    )
}
export default JsonScreenHoc(BadgeComponent);

BadgeComponent.propTypes = {
    component: PropTypes.object,
    containerArrayPath: PropTypes.string,
    actionsContext: PropTypes.object
}